import { ActionEnum } from "../action.enum";
import { OrganizationModel } from "../../models/organization/organization.model";

export namespace OrganizationDetailAction {

  export class LoadOrganization {
    static readonly type = ActionEnum.ORGANIZATION_DETAIL_LOAD_ORGANIZATION;

    constructor(public id: string) {
    }
  }

  export class ResetState {
    static readonly type = ActionEnum.ORGANIZATION_DETAIL_RESET_STATE;

    constructor() {
    }
  }

  export class Update {
    static readonly type = ActionEnum.ORGANIZATION_DETAIL_UPDATE;

    constructor(public model: OrganizationModel) {
    }
  }

  export class Delete {
    static readonly type = ActionEnum.ORGANIZATION_DETAIL_DELETE_ORGANIZATION;

    constructor() {
    }
  }

  export class RefreshOrganizationLogo {
    static readonly type = ActionEnum.ORGANIZATION_DETAIL_REFRESH_ORGANIZATION_LOGO;
    constructor (public orgLogoId: string) {}
  }

  export class MakeServiceProviderGloballyVisible {
    static readonly type = ActionEnum.ORGANIZATION_DETAIL_MAKE_SERVICE_PROVIDER_GLOBALLY_VISIBLE;
    constructor() {}
  }

}
